import { useSelector } from 'react-redux';
import { useRouter } from '@wix/tpa-router/react';

import { SortOrder } from '@wix/ambassador-social-groups-v2-group-member-with-profile/types';

import { queryGroupMembers } from 'api/members';

import { useController } from 'common/context/controller';
import { useHttpClient } from 'common/hooks/useHttpClient';

import { selectGroupSlugById } from 'store/selectors';

import zIndex from '../../../../wui/theme/z-index.scss';

export const EVERYONE_MENTION_GUID = 'everyone';
export const EVERYONE_MENTION_DISPLAY_NAME = 'Everyone';

type Mention = {
  id: string;
  name: string;
  avatar?: string;
  type?: 'GROUP';
};

export function useMentions(groupId: string, isComments?: boolean) {
  const router = useRouter();

  const { members$ } = useController();
  const slug = useSelector(selectGroupSlugById(groupId));

  const httpClient = useHttpClient();

  return {
    getMentions,
    onMentionClick,
    visibleItemsBeforeOverflow: 20,
    // TODO: fix types in RICOS
    zIndex: String(zIndex.zIndex_POPOVER) as any as number,
  };

  function onMentionClick(mention: Mention) {
    const isEveryone =
      mention.id === EVERYONE_MENTION_GUID || mention.type === 'GROUP';

    if (isEveryone) {
      router.go('group.members', { slug });
    } else {
      members$.navigateToMember?.({ memberId: mention.id });
    }
  }

  async function getMentions(query: string) {
    const { data } = await httpClient.request(
      queryGroupMembers(groupId, {
        paging: {
          limit: 20,
        },
        sort: [
          {
            fieldName: 'profile.nickname',
            order: SortOrder.ASC,
          },
        ],
        filter: {
          'profile.nickname': {
            $contains: query,
          },
        },
      }),
    );

    const members: Mention[] = data.members.map((member) => ({
      id: member.memberId as string,
      name: member.name,
      avatar: member.imageUrl,
    }));

    if (
      EVERYONE_MENTION_DISPLAY_NAME.toLowerCase().includes(query.toLowerCase())
    ) {
      members.unshift({
        type: 'GROUP',
        id: isComments ? groupId : EVERYONE_MENTION_GUID,
        name: EVERYONE_MENTION_DISPLAY_NAME,
      });
    }

    return members;
  }
}
